__turbopack_context__.v({
  "forgotPassword": "LoginFields-module-scss-module__S8yXIq__forgotPassword",
});
